import { type, Schema, ArraySchema } from '@colyseus/schema';

export const MAX_TEAMS = 4;

export class Team extends Schema {
    @type("string") id: string = ''; // Team identifier (e.g., "team_1", "team_2", etc.)
    @type("int8") teamNumber: number = 1; // Team number (1-4) for easy reference
    @type("string") name: string = ''; // Display name (can be customized by GM)
    @type("string") color: string = 'red-400'; // Team color ID for UI
    @type(["string"]) memberSessionIds = new ArraySchema<string>(); // Player session IDs in this team
    @type("number") totalScore: number = 0; // Team total score (calculated)
    @type("number") adjustedScore: number = 0; // Team score after asymmetric adjustment
    @type("number") bestStreak: number = 0; // Best streak among team members (for Endless mode)
    
    // Fight mode specific properties
    @type("int32") currentHp: number = 10000; // Current HP (for Fight mode)
    @type("int32") maxHp: number = 10000; // Max HP (for Fight mode)
    @type("boolean") isEliminated: boolean = false; // Whether team is eliminated (HP <= 0)
    @type("number") lastRoundDamage: number = 0; // Damage taken in last round (for display)

    constructor(id?: string, name?: string, color?: string, teamNumber?: number) {
        super();
        if (id) this.id = id;
        if (name) this.name = name;
        if (color) this.color = color;
        if (teamNumber) this.teamNumber = teamNumber;
    }

    get memberCount(): number {
        return this.memberSessionIds.length;
    }

    hasMember(sessionId: string): boolean {
        return this.memberSessionIds.includes(sessionId);
    }

    addMember(sessionId: string): boolean {
        if (!this.hasMember(sessionId)) {
            this.memberSessionIds.push(sessionId);
            return true;
        }
        return false;
    }

    removeMember(sessionId: string): boolean {
        const index = this.memberSessionIds.indexOf(sessionId);
        if (index !== -1) {
            this.memberSessionIds.splice(index, 1);
            return true;
        }
        return false;
    }
}

export class TeamRanking extends Schema {
    @type("string") teamId: string = '';
    @type("string") name: string = '';
    @type("string") color: string = '';
    @type("number") totalScore: number = 0;
    @type("number") adjustedScore: number = 0;
    @type("number") bestStreak: number = 0;
    @type("int8") memberCount: number = 0;
    @type("int8") rank: number = 0;
    
    // Fight mode specific
    @type("int32") finalHp: number = 0; // HP at game end
    @type("int32") maxHp: number = 0; // Max HP for reference
    @type("boolean") isEliminated: boolean = false;
}
